import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Button from "../button/Button";
import { BoltIcon } from "../../../icons";

interface Props {
    title?: string;
    description?: string;
}

export default function SubscriptionRestrictedState({ title, description }: Props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center p-8 text-center bg-gray-50 dark:bg-gray-800/50 rounded-2xl border border-border-subtle border-dashed min-h-[300px]">
            <div className="w-16 h-16 bg-accent-tint text-accent-text rounded-full flex items-center justify-center mb-4">
                <BoltIcon className="size-8" />
            </div>

            <h3 className="text-xl font-semibold text-content-primary mb-2">
                {title || t("subscription.restricted.title", "This feature is only for Plus members")}
            </h3>

            <p className="text-gray-500 max-w-md mb-6">
                {description || t("subscription.restricted.description", "Upgrade your plan to unlock unlimited access to this and other premium features.")}
            </p>

            <Button
                onClick={() => navigate("/subscription")}
                startIcon={<BoltIcon className="size-5" />}
            >
                {t("subscription.status.upgrade", "Upgrade to Plus")}
            </Button>
        </div>
    );
}
